export const fmt = (v) => `$${(v || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

// Generate month options for the last 12 months + next 3
const generateMonthOptions = () => {
  const opts = [{ value: 'all', label: 'All Months' }];
  const now = new Date();
  // Add quarterly options for the current year and last year
  for (let yr = now.getFullYear(); yr >= now.getFullYear() - 1; yr--) {
    for (let q = 4; q >= 1; q--) {
      // Only show quarters that have at least partially passed
      const qEnd = new Date(yr, q * 3, 0); // last day of quarter
      if (qEnd > now && !(yr === now.getFullYear() && q === Math.ceil((now.getMonth() + 1) / 3))) continue;
      const labels = { 1: 'Jan-Mar', 2: 'Apr-Jun', 3: 'Jul-Sep', 4: 'Oct-Dec' };
      opts.push({ value: `Q${q}-${yr}`, label: `Q${q} ${yr} (${labels[q]})` });
    }
  }
  // Monthly options
  for (let i = -3; i <= 12; i++) {
    const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
    const val = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
    const label = d.toLocaleDateString('en-US', { year: 'numeric', month: 'short' });
    opts.push({ value: val, label });
  }
  return opts;
};
export const MONTH_OPTIONS = generateMonthOptions();

export const PAYROLL_STAGES = ["Awaiting Time / Processing", "Pending Review", "Approved", "Paid / Distributed"];

export const stageColors = {
  "Awaiting Time / Processing": "bg-amber-500/15 text-amber-400 border-amber-500/30",
  "Awaiting Time": "bg-amber-500/15 text-amber-400 border-amber-500/30",
  "Pending Review": "bg-blue-500/15 text-blue-400 border-blue-500/30",
  "Approved": "bg-emerald-500/15 text-emerald-400 border-emerald-500/30",
  "Paid / Distributed": "bg-violet-500/15 text-violet-400 border-violet-500/30",
  "Paid": "bg-violet-500/15 text-violet-400 border-violet-500/30",
};

// Normalize stage names from DB variants to canonical names
export const normalizeStage = (stage) => {
  const aliases = {
    "Awaiting Time": "Awaiting Time / Processing",
    "Awaiting Time/Processing": "Awaiting Time / Processing",
    "Paid": "Paid / Distributed",
    "Paid/Distributed": "Paid / Distributed",
  };
  return aliases[stage] || stage;
};

export const ACCOUNT_OPTIONS = [
  "Accounts Receivable", "Cash / Bank", "Service Revenue", "Office Supplies",
  "Rent / Lease", "Payroll Expense", "Travel Expense", "Utilities", "Insurance",
  "Professional Fees", "Reimbursable Expenses", "Other Expense", "Other Income"
];
